<script>
import MenuHamburguer from "./MenuHamburguer.vue";
export default {
  components: {
    MenuHamburguer,
  },
  data() {
    return {
      toggleMenu: false,
    };
  },
};
</script>

<template>
  <header :class="{ menuOpen: toggleMenu }" class="animated-top">
    <router-link to="/" class="logo-dark"> </router-link>
    <span class="overlaySide"></span>
    <nav>
      <div class="wrapper-buttons">
        <router-link to="/login" class="btn">Entrar</router-link>
        <router-link to="/criar-conta" class="btn btn-primary"
          >Registrar</router-link
        >
      </div>
    </nav>
    <menu-hamburguer
      class="toggleMenu"
      @hamburguerState="toggleMenu = $event"
    />
  </header>
</template>

<style scoped>
.btn:before,
.btn::after {
  display: none;
}

.btn {
  border-radius: 60px;
}

.btn.btn-primary {
  background-color: #2f80ed;
}

.toggleMenu {
  display: none !important;
}

header {
  padding-top: 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
}

.overlaySide {
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100vw;
  height: 100vh;
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 65%) -90%,
    transparent
  );
  transform: translateX(100%);
  opacity: 0;
  transition: 0.5s;
  display: none;
}

.logo-light {
  align-self: flex-start;
}

nav a {
  color: #000;
  transition: var(--slow-med);
}

nav a.btn.btn-primary {
  color: #fff;
}

a:hover::after,
a::after {
  background-color: var(--grey-4);
}

nav a:hover {
  color: var(--grey-4);
}

nav,
.wrapper-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
}

@media screen and (max-width: 995px) {
  header {
    align-items: center;
    padding-top: 1.5rem;
  }

  nav {
    gap: 1rem;
    height: 100vh;
    width: calc(100% - 2rem);
    max-width: 304px;
    position: fixed;
    top: 0px;
    right: -0.5rem;
    background-color: #0e1135;
    z-index: 100;
    transition: 0.4s;
    transform: translateX(100%);
    display: block;
  }

  .menuOpen nav {
    transform: translateX(0%);
    display: block;
  }

  .overlaySide {
    display: block;
  }

  .menuOpen .overlaySide {
    transform: translateX(0%);
    opacity: 1;
  }

  .toggleMenu {
    display: flex !important;
  }

  nav .wrapper-buttons {
    gap: 0.5rem;
    width: calc(100% - 2rem);
    margin: 100px auto;
    flex-direction: column;
  }

  nav .btn {
    width: 100%;
  }

  .logo-dark {
    height: 40px;
    width: 100%;
    max-width: 150px;
  }
}
</style>